import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MAIN_API_URL } from "../utils/auth";
import '../../css/navBar.css'

export default function AdminNavBar({ site_name }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  // ✅ Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
    setMenuOpen(false);
  }, [location.pathname]);

  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isActive = (path) => {
    if (!path || path === "#") return "";
    return location.pathname === path || location.pathname.startsWith(`${path}/`)
      ? "active"
      : "";
  };

  const handleLogout = async () => {
    try {
      const refreshToken = localStorage.getItem("refresh");
      const accessToken = localStorage.getItem("access");

      const response = await fetch(`${MAIN_API_URL}/logout/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        credentials: "include",
        body: JSON.stringify({ refresh_token: refreshToken }),
      });

      if (response.ok) {
        localStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <nav className="bookcase-navbar">
      <div className="nav-inner">
        {/* Logo */}
        <Link to="/admin" className="nav-logo">
          {site_name}
        </Link>

        {/* Mobile Hamburger */}
        <button
          className="menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div className={menuOpen ? "bar open" : "bar"}></div>
        </button>

        {/* Main Nav */}
       <div className={`nav-links ${menuOpen ? "open" : ""}`}>
  <Link to="/admin" className={isActive("/admin")}>
    Home
  </Link>

  <Link to="/admin/users" className={isActive("/admin/users")}>
    Users
  </Link>

  <Link to="/admin/plans" className={isActive("/admin/plans")}>
    Plans
  </Link>

  {/* TODO: Create Admin Orders Page */}
  <Link to="/admin/transactions" className={isActive("/admin/transactions")}>
    Transactions
  </Link>

  <Link to="/admin/support" className={isActive("/admin/support")}>
    Support
  </Link>

  <Link to="/admin/books" className={isActive("/admin/books")}>
    Books
  </Link>

  <Link to="/admin/gifts" className={isActive("/admin/gifts")}>
    Gifts
  </Link>

  <Link to="/admin/achievements" className={isActive("/admin/achievements")}>
    Achievements
  </Link>

  <Link to="/admin/prompts" className={isActive("/admin/prompts")}>
    Prompts
  </Link>

  {/* Dropdown */}
  <div className="nav-dropdown" ref={dropdownRef}>
    <button
      type="button"
      className="dropdown-label"
      onClick={(e) => {
        e.stopPropagation();
        setDropdownOpen(prev => !prev);
      }}
    >
      Settings ▾
    </button>

    <div className={`dropdown-panel ${dropdownOpen ? "show" : ""}`}>

      <Link
        to="/admin/settings"
        className="dropdown-item"
        onClick={() => setDropdownOpen(false)}
      >
        Site Settings
      </Link>

      <Link
        to="/admin/notifications"
        className="dropdown-item"
        onClick={() => setDropdownOpen(false)}
      >
        Notifications
      </Link>

      <Link
        to="southcentraldev.com/ops"
        className="dropdown-item"
        onClick={() => setDropdownOpen(false)}
      >
        Mother
      </Link>

      <div className="dropdown-divider"></div>

      <button
        className="dropdown-item logout-btn"
        onClick={() => {
          setDropdownOpen(false);
          handleLogout();
        }}
      >
        Log Out
      </button>
    </div>
  </div>
</div>
      </div>
    </nav>
  );
}
